export default interface AccountService {
  AccountServiceID: number
  ImplementationID: number
  AccountID?: number
  ServiceID: number
  Active: boolean
  IsDefault: boolean
}




export function AccountServicesByServiceId(items: AccountService[], serviceId: number): AccountService[] {
  let result = [];
  for (let i = 0; i < items.length; i++) {
    if (items[i].ServiceID === serviceId) {
      result.push(items[i]);
    }
  }
  return result;
}


export function ActiveAccountServicesByServiceId(items: AccountService[], serviceId: number): AccountService[] {
  let result = [];
  for (let i = 0; i < items.length; i++) {
    if (((!!items[i].AccountID && items[i].Active) || (!items[i].AccountID && items[i].Active && items[i].IsDefault)) && (items[i].ServiceID === serviceId)) {
      result.push(items[i]);
    }
  }
  return result;
}

export function HasActiveAccountServicesByServiceId(items: AccountService[], serviceId: number):  boolean{
  let activeItems = ActiveAccountServicesByServiceId(items, serviceId);
  
  if(activeItems.length > 0){
    return true;
  }
  return false;
}